module.exports = __webpack_public_path__ + "img/icon.0b4ed960.png";